// Import scripts.
import CouponLabel from '../shared/wc_block_coupon_label';
import CouponForceApply from '../shared/wc_block_coupon_force_apply';
// Initiate scripts.
CouponLabel();
CouponForceApply();
